import { Paper, Skeleton, Typography } from '@mui/material'
import React from 'react'
import Button from '../atoms/Button'
import GoogleMaps2 from '../molecules/GoogleMaps2'
import TitleSubtitle from '../molecules/TitleSubtitle'
import strips from '../../media/strips.svg'
import Figures from '../molecules/Figures'
import BodyHeader from '../molecules/BodyHeader'

import chairSun from '../../media/chair-sun.svg'
import Zone from '../organisms/Zone'

import useShop from '../../hooks/useShop'
import useFigures from '../../hooks/useFigures'
import { APP_BASE_URL, CATEGORIES, GIFT_OBJECT_URL, SERVICES } from '../../constants'
import useDefaultLeftRight from '../../hooks/useDefaultLeftRight'

import instaSrc from '../../media/insta_button_icon.svg'
import chairIcon from '../../media/chair_green_icon.svg'
const Shops = () => {
	const { isLoading, title, content } = useShop()
	const { figures } = useFigures(CATEGORIES.FIGURES.BOUTIQUE.id)
	const { data: boutiques } = useDefaultLeftRight(SERVICES.BOUTIQUE)
	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}

			{boutiques &&
				boutiques.map(({ id, type, slug, title, content }, index) => (
					<Zone color={(index % 2 === 0 && 'white') || 'ivory'} key={id} id={slug}>
						<TitleSubtitle title={type} subtitle={title} />
						<Typography
							sx={(theme) => ({
								color: 'text.primary',
								textAlign: 'left',
								fontSize: 18,
								mt: 4,
								display: 'flex',
								width: '100%',
								flexFlow: (index % 2 === 1 && 'row-reverse wrap') || 'row wrap',
								fontFamily: 'montserrat',
								justifyContent: 'space-between',

								px: 2,

								[theme.breakpoints.down('md')]: {
									mt: 2,
								},

								'& figure': {
									pt: 4,
									m: 0,
									display: 'flex',
									justifyContent: (index % 2 === 0 && 'flex-start') || 'flex-end',

									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										pt: 0,
										flexBasis: '100%',
									},

									'& img': {
										display: 'block',
										overflow: 'hidden',
										borderRadius: '8px',

										height: 'fit-content!important',
										width: '100%!important',

										[theme.breakpoints.down('md')]: {
											width: '100%',
										},
									},
								},
								'& em': {
									fontSize: 16,
								},

								'& a': {
									color: 'secondary.main',
									fontWeight: 'bold',
								},

								'& h2': {
									fontSize: 22,
									fontWeight: 800,
									color: 'text.primary',
									mb: 2,
									background: (theme) => `url(${chairIcon}) no-repeat ${theme.spacing(0, 1)}`,
									pl: 4.5,
									display: 'table',
									[theme.breakpoints.down('md')]: {
										fontSize: 19,
										backgroundPositionY: 6,
										backgroundSize: 15,
										pl: 3,
										fontWeight: 900,
									},
								},
								'& pre': {
									borderLeft: `4px solid ${theme.palette.secondary.main}`,
									fontWeight: 700,
									fontFamily: 'montserrat',
									p: theme.spacing(0, 0, 0, 2),
									whiteSpace: 'break-spaces',

									'& .MuiTypography-root': {
										[theme.breakpoints.down('md')]: {
											fontSize: 16,
											p: theme.spacing(0, 0, 0, 2),
										},
									},
								},
								'& blockquote': {
									m: 0,
									my: 2,
									fontSize: 22,
									'& p': {
										fontWeight: 'bold',
										mb: 0,
									},

									'& cite': {
										fontSize: 16,
										fontWeight: 400,
										position: 'relative',
										fontStyle: 'normal',
										textAlign: 'right',
										display: 'block',
									},
								},

								'& .wp-block-group': {
									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										flexBasis: '100%',
									},
								},

								'& .wp-block-buttons': {
									display: 'flex',
									justifyContent: 'space-around',

									'& .wp-block-button:nth-of-type(2) a': {
										backgroundColor: 'white',
										color: 'secondary.main',
										textDecoration: 'none',

										background: `white url(${instaSrc}) no-repeat bottom 8px right 15px`,
										pr: 6,
									},
								},

								'& .wp-block-button__link': {
									fontFamily: 'museomoderno',
									cursor: 'pointer',
									position: 'relative',
									display: 'inline-block',
									borderRadius: '28px',
									fontSize: 16,
									p: theme.spacing(1, 2),
									bgcolor: 'secondary.main',
									color: 'white',
									fontWeight: 700,
									my: theme.spacing(2),
									minWidth: 169,
									border: `3px solid ${theme.palette.secondary.main}`,

									'&:hover': {
										bgcolor: 'secondary.main',
										border: `3px solid ${theme.palette.secondary.main}`,
									},

									[theme.breakpoints.down('md')]: {
										display: 'flex',
										m: theme.spacing(0, 'auto'),
										mt: 10,

										'& a': {
											display: 'flex',
											p: 3,
											border: 'none',
										},
									},
								},
								'& div': { width: '100%' },
							})}
							component="div"
							dangerouslySetInnerHTML={{ __html: content }}
						/>
					</Zone>
				))}

			<Zone color="white">
				<GoogleMaps2 />
				<Typography
					sx={(theme) => ({
						fontSize: 32,
						fontWeight: 700,
						m: (theme) => theme.spacing(6, 3, 2),
						color: 'text.primary',
						[theme.breakpoints.down('md')]: {
							mx: 0,
							mt: 10,
						},
					})}
				>
					Vous avez des objets à donner ?
				</Typography>
				<Typography
					sx={(theme) => ({
						fontSize: 18,
						fontWeight: 400,
						px: 30,
						color: 'text.primary',
						[theme.breakpoints.down('md')]: {
							mx: 0,
							px: 0,
						},
					})}
				>
					Donnez-nous les objets dont vous ne vous servez plus et participez ainsi à la réduction
					des déchets. Ils seront nettoyés, restaurés et revendus à prix solidaire.
				</Typography>
				<Button
					bgColor="green"
					color="white"
					label="En savoir plus sur le don d’objets"
					href={`${APP_BASE_URL}${GIFT_OBJECT_URL}`}
				/>
			</Zone>

			<Paper
				sx={(theme) => ({
					bgcolor: 'primary.main',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(16, 14),
					backgroundImage: `url(${strips})`,
					backgroundRepeat: 'round no-repeat',

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
						backgroundRepeat: 'no-repeat',
					},
				})}
			>
				<img src={chairSun} alt="Le cycle du réemploi solidaire" />
				<Typography
					sx={(theme) => ({
						fontWeight: 700,
						fontSize: 18,
						px: 10,
						mt: 2,
						lineHeight: 1.2,
						[theme.breakpoints.down('md')]: {
							px: 0,
							mx: 0,
							fontSize: 19,
							fontWeight: 800,
							my: 2,
						},
					})}
				>
					La vente solidaire : garante du réemploi et pilier économique de la ressourcerie
				</Typography>
				<Typography
					sx={(theme) => ({
						fontWeight: 400,
						fontSize: 16,
						mt: 4,
						px: 10,
						[theme.breakpoints.down('md')]: {
							px: 0,
							fontSize: 16,
							my: 2,
						},
					})}
				>
					L'activité de vente solidaire est une activité de gestion des déchets à part entière.
					C'est elle qui permet la réemployabilité et qui organise la sortie du flux de matières et
					d'objet qui nous parviennent.{' '}
				</Typography>
				<Typography
					sx={(theme) => ({
						fontWeight: 700,
						fontSize: 16,
						mt: 1,
						px: 10,
						[theme.breakpoints.down('md')]: {
							px: 0,
						},
					})}
				>
					Ces deux objectifs fondateurs sont inciter le plus grand nombre à consommer des objets
					issus du réemploi plutôt que neuf et permettre au plus en difficulté d'accéder aux biens
					de consommation courants
				</Typography>
			</Paper>
			<Paper
				sx={(theme) => ({
					bgcolor: 'text.primary',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(10, 14),

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
					},
				})}
			>
				<TitleSubtitle
					subtitle="La Collecterie en chiffres"
					title="depuis 2012"
					color="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Paper>
		</>
	)
}

export default Shops
